module.exports = __webpack_public_path__ + "static/media/e12.aeee3640.gif";